var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEluvio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7604_2579)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.064 6.336V17.664H16.128V16.128H9.6V12.672H15.552V11.136H9.6V7.872H16.128V6.336H8.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 16.896C19.2 17.3202 18.8562 17.664 18.432 17.664C18.0078 17.664 17.664 17.3202 17.664 16.896C17.664 16.4718 18.0078 16.128 18.432 16.128C18.8562 16.128 19.2 16.4718 19.2 16.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.656C17.8851 22.656 22.656 17.8851 22.656 12C22.656 6.11485 17.8851 1.344 12 1.344C6.11485 1.344 1.344 6.11485 1.344 12C1.344 17.8851 6.11485 22.656 12 22.656ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7604_2579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEluvio);
export default __webpack_public_path__ + "static/media/eluvio.fe5eff02b81be3377fe0620d7cb32a91.svg";
export { ForwardRef as ReactComponent };